import React from "react";
import { Box, Stack } from "@mui/material";
import { Task } from "model/activitiesModel";
import MobileTaskCard from "./MobileTaskCard";
import EmptyMobileTasks from "./EmptyMobileTasks";

interface MobileTaskListProps {
  tasks: Task[];
  emptyMessage: string;
  emptyAccent?: string;
  onTaskClick: (idprocesstoken: number) => void;
  onNextStep?: (task: Task) => void | Promise<void>;
  onBackStep?: (task: Task) => void | Promise<void>;
  translations: Record<string, string>;
}

/**
 * Vertical scrollable list of MobileTaskCard. Renders EmptyMobileTasks when empty.
 */
const MobileTaskList: React.FC<MobileTaskListProps> = ({
  tasks,
  emptyMessage,
  emptyAccent,
  onTaskClick,
  onNextStep,
  onBackStep,
  translations,
}) => {
  if (tasks.length === 0) {
    return <EmptyMobileTasks message={emptyMessage} accentColor={emptyAccent} />;
  }

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        px: 1.5,
        py: 1.5,
        // Hide scrollbar on iOS / mobile
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      <Stack spacing={1.25}>
        {tasks.map((task) => (
          <MobileTaskCard
            key={task.idprocesstoken}
            task={task}
            onClick={() => onTaskClick(task.idprocesstoken)}
            onNext={onNextStep}
            onBack={onBackStep}
            translations={translations}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default MobileTaskList;